export default "__VITE_PUBLIC_ASSET__80dd2bfd__"